module.exports = __webpack_public_path__ + "static/img/logo_title.3467faa3.png";